/**
  Minimalist Sticky Add to Cart (ATC) Bar for Mobile
  Triggers when the user scrolls past the main product buy button.
*/
document.addEventListener('DOMContentLoaded', () => {
  // Only execute on mobile screens (< 750px)
  if (window.innerWidth >= 750) return;

  const mainFormButton = document.querySelector('button[name="add"], .product-form__submit');
  if (!mainFormButton) return;

  // Extract product details from DOM
  const titleEl = document.querySelector('.product__title h1') || document.querySelector('h1');
  const priceEl = document.querySelector('.price .price-item--sale, .price .price-item--regular') || document.querySelector('.price-item');
  
  if (!titleEl) return;

  const titleText = titleEl.textContent ? titleEl.textContent.trim() : '';
  const priceText = priceEl ? priceEl.textContent.trim() : '';

  // Create sticky bar container
  const stickyBar = document.createElement('div');
  stickyBar.className = 'sticky-atc-bar';
  stickyBar.innerHTML = `
    <div class="sticky-atc-bar__container">
      <div class="sticky-atc-bar__info">
        <div class="sticky-atc-bar__title">${titleText}</div>
        <div class="sticky-atc-bar__price">${priceText}</div>
      </div>
      <button type="button" class="button sticky-atc-bar__button">ADD TO CART</button>
    </div>
  `;

  document.body.appendChild(stickyBar);

  const stickyButton = stickyBar.querySelector('.sticky-atc-bar__button');

  // Trigger main form submit when sticky button is clicked
  stickyButton.addEventListener('click', (e) => {
    e.preventDefault();
    if (mainFormButton.disabled) return;

    // Show loading state
    stickyButton.classList.add('loading');
    stickyButton.textContent = 'ADDING...';

    // Click original form button to trigger theme's Ajax cart drawer/popup
    mainFormButton.click();

    // Reset button label state after short delay
    setTimeout(() => {
      stickyButton.classList.remove('loading');
      stickyButton.textContent = mainFormButton.textContent.trim().toUpperCase() || 'ADD TO CART';
    }, 1500);
  });

  // Performant IntersectionObserver to toggle visibility of sticky bar
  const observerOptions = {
    root: null,
    threshold: 0,
    rootMargin: '0px'
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      // Show sticky bar only when original button is above viewport (scrolled past)
      if (!entry.isIntersecting && window.scrollY > entry.boundingClientRect.top) {
        stickyBar.classList.add('visible');
        // Keep state in sync (e.g. if variant becomes Sold Out)
        stickyButton.disabled = mainFormButton.disabled;
        stickyButton.textContent = mainFormButton.textContent.trim().toUpperCase() || 'ADD TO CART';
      } else {
        stickyBar.classList.remove('visible');
      }
    });
  }, observerOptions);

  observer.observe(mainFormButton);
});
